import { render, staticRenderFns } from "./MapOt_Demo.vue?vue&type=template&id=0bf36cc3&"
import script from "./MapOt_Demo.vue?vue&type=script&lang=js&"
export * from "./MapOt_Demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports